import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { SegmentTagMap } from '../shared/analytics/models/segment-tag-map.model'
import { ScheduleComponent } from '../schedule/schedule.component'
import { EmptyTab } from './components/event-detail/event-tabs/empty-tab/empty-tab.component'
import { EventHubSmartComponent } from '../event-hub/event-hub-smart.component'
import { pathMatcher } from '../shared/utility-functions/slug.utility'
import { CORE_ID_RULES } from '../shared/utility-functions/regex.utility'
import { SCHEDULE_TAG } from '../schedule/schedule-analytics.service'
import { NextGenEventHubGuard } from './next-gen-event-hub.guard'

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: '',
        component: ScheduleComponent,
        data: {
          noTopScroll: false,
          shouldShowEventTicker: false,
          /**
           * This will both prevent automatic page calls and also allow the
           * analytics directive to work for track calls.
           *
           * @see outExcludedRoutes
           */
          segment: SCHEDULE_TAG,
          shouldShowAdSkin: true
        }
      },
      {
        matcher: url => pathMatcher(url, 'slug', CORE_ID_RULES),
        component: EventHubSmartComponent,
        canActivate: [NextGenEventHubGuard],
        data: {
          shouldShowAdSkin: false,
          shouldShowEventTicker: true
        },
        children: [
          {
            path: '',
            component: EmptyTab,
            data: {
              tab: 'root',
              segment: SegmentTagMap.EVENT_DETAIL // Needed to prevent duplicate page calls
            }
          },
          {
            path: 'videos',
            component: EmptyTab,
            data: {
              tab: 'videos',
              noTopScroll: true,
              segment: SegmentTagMap.EVENT_DETAIL // Needed to prevent duplicate page calls
            }
          },
          {
            path: 'news',
            component: EmptyTab,
            data: {
              tab: 'news',
              noTopScroll: true,
              segment: SegmentTagMap.EVENT_DETAIL // Needed to prevent duplicate page calls
            }
          },
          {
            path: 'entries',
            component: EmptyTab,
            data: {
              tab: 'entries',
              noTopScroll: true,
              segment: SegmentTagMap.EVENT_DETAIL // Needed to prevent duplicate page calls
            }
          },
          {
            path: 'schedule',
            component: EmptyTab,
            data: {
              tab: 'schedule',
              noTopScroll: true,
              segment: SegmentTagMap.EVENT_DETAIL // Needed to prevent duplicate page calls
            }
          },
          {
            path: 'results',
            component: EmptyTab,
            data: {
              tab: 'results',
              noTopScroll: true,
              isViewAll: false,
              segment: SegmentTagMap.EVENT_DETAIL // Needed to prevent duplicate page calls
            }
          },
          {
            path: 'results/view-all',
            component: EmptyTab,
            data: {
              tab: 'results',
              noTopScroll: false,
              isViewAll: true,
              segment: SegmentTagMap.EVENT_DETAIL // Needed to prevent duplicate page calls
            }
          },
          {
            path: 'live-updates',
            component: EmptyTab,
            data: {
              tab: 'live-updates',
              noTopScroll: true,
              segment: SegmentTagMap.EVENT_DETAIL // Needed to prevent duplicate page calls
            }
          },
          {
            path: 'info',
            component: EmptyTab,
            data: {
              tab: 'info',
              noTopScroll: true,
              segment: SegmentTagMap.EVENT_DETAIL // Needed to prevent duplicate page calls
            }
          },
          {
            path: 'collections',
            component: EmptyTab,
            data: {
              tab: 'collections',
              noTopScroll: true,
              segment: SegmentTagMap.EVENT_DETAIL // Needed to prevent duplicate page calls
            }
          },
          {
            path: 'brackets',
            component: EmptyTab,
            data: {
              tab: 'brackets',
              noTopScroll: true,
              segment: SegmentTagMap.EVENT_DETAIL // Needed to prevent duplicate page calls
            }
          }
        ]
      }
    ])
  ],
  exports: [RouterModule]
})
export class EventsRoutingModule {}
